import type { ISwSettings } from "app/@types/ISwSettings";

export const isAeoSolution = (swSettings: ISwSettings): boolean =>
    swSettings?.user?.customData?.quiz?.UserChosenSolution === "ai-solution";
